import { memo } from 'react';
import { Tooltip } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import type { ReactionNameEnum } from '../ReactionIcons';
import { ReactionIcon, translationKeysByName } from '../ReactionIcons';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const cursorBlock = require('@hotjar/shared-assets/icons/cursor-block.ico');

const StyledButton = styled.button`
  background: transparent;
  border: 0;
  outline: none;
  padding: 0;
  transition: transform 0.2s ease-out;
  cursor: pointer;

  &[disabled] {
    filter: grayscale(100%);
    cursor: url(${cursorBlock}), default;
  }

  &:hover {
    transform: scale(1.2);
  }
`;

interface Props {
  reactionName: ReactionNameEnum;
  onClick: () => void;
  size?: 'm' | 'l' | 'xl';
  disabled?: boolean;
}

const AddReactionBtn = ({
  reactionName,
  onClick,
  disabled = false,
  size = 'l',
}: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Tooltip text={t(translationKeysByName[reactionName])}>
      <StyledButton onClick={onClick} disabled={disabled}>
        <ReactionIcon name={reactionName} size={size} />
      </StyledButton>
    </Tooltip>
  );
};

export const AddReactionButton = memo(AddReactionBtn);
